import React, { useState } from 'react';
import Styles from './CarrosEletricosBannerImg.css';
import RedButton from '../../atoms/RedButton';
import Container from '../../atoms/Container';

function CarrosEletricosBannerImg() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section className={'banner_mobile'}>
        <div className="img-container">
          <a
            href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=financiar-veiculo-eletrico:banner&int_campaign=black-feirao#/dados-pessoais"
            target="_blank"
            rel="noopener"
          >
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 361 && (
                  <picture>
                    {/* <source
                              type="image/webp"
                              srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-360.webp"
                            /> */}
                    <source
                      type="image/png"
                      srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-360.png"
                    />
                    <img
                      src="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-360.png"
                      alt="Black Feirão dá uma força pra você conquistar seu carro elétrico! Garanta condições exclusivas pra colocar seu sonho na garagem. Ver ofertas"
                      className="img-600"
                    />
                  </picture>
                )}
                {width > 361 && width <= 576 && (
                  <picture>
                    {/* <source
                              type="image/webp"
                              srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-575.webp"
                            /> */}
                    <source
                      type="image/png"
                      srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-575.png"
                    />
                    <img
                      src="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-575.png"
                      alt="Black Feirão dá uma força pra você conquistar seu carro elétrico! Garanta condições exclusivas pra colocar seu sonho na garagem. Ver ofertas"
                      className="img-992 rp"
                    />
                  </picture>
                )}
                {width > 576 && width <= 992 && (
                  <picture>
                    {/* <source
                              type="image/webp"
                              srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-991.webp"
                            /> */}
                    <source
                      type="image/png"
                      srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-991.png"
                    />
                    <img
                      src="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-991.png"
                      alt="Black Feirão dá uma força pra você conquistar seu carro elétrico! Garanta condições exclusivas pra colocar seu sonho na garagem. Ver ofertas"
                      className="img-1320"
                    />
                  </picture>
                )}
              </>
            )}
          </a>
        </div>
      </section>

      <section className={'banner_desk'}>
        <Container>
          <div className="img-container">
            <a
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=financiar-veiculo-eletrico:banner&int_campaign=black-feirao#/dados-pessoais"
              target="_blank"
              rel="noopener"
            >
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width <= 1200 && (
                    <picture>
                      {/* <source
                              type="image/webp"
                              srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-1110.webp"
                            /> */}
                      <source
                        type="image/png"
                        srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-1110.png"
                      />
                      <img
                        src="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-1110.png"
                        alt="Black Feirão dá uma força pra você conquistar seu carro elétrico! Garanta condições exclusivas pra colocar seu sonho na garagem. Ver ofertas"
                        className="img-600"
                      />
                    </picture>
                  )}
                  {width > 1200 && (
                    <picture>
                      {/* <source
                              type="image/webp"
                              srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-1238.webp"
                            /> */}
                      <source
                        type="image/png"
                        srcSet="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-1238.png"
                      />
                      <img
                        src="assets/carros-eletricos/banner-black-feirao-24/black-feirao-24-1238.png"
                        alt="Black Feirão dá uma força pra você conquistar seu carro elétrico! Garanta condições exclusivas pra colocar seu sonho na garagem. Ver ofertas"
                        className="img-992 rp"
                      />
                    </picture>
                  )}
                </>
              )}
            </a>
          </div>
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosBannerImg;
